module.exports = wp["htmlEntities"];